import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Box, Typography, Card, CardContent, Tooltip, useTheme, LinearProgress, Chip, CardHeader, Container, Divider, IconButton, Hidden, Tab, Tabs, TableBody, TableCell, TableHead, TableRow, Alert, Stack, Badge, ToggleButton, ToggleButtonGroup, useMediaQuery } from '@mui/material';
import { Helmet } from 'react-helmet';
import { RootState } from '../store/store';
import AppConstants from '../constants/AppConstants';
import LiveGeotab from './LiveGeotab';
import DashboardFatigue from './DashboardFatigue';
import DashboardToday from './DashboardToday';

const MyDashboard: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState(0); // 0 = Ongoing, 1 = Scheduled, 2 = Completed

  const handleTabChange = (event: any, newValue: any) => {
    setSelectedTab(newValue);
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const tabSx = {
    minWidth: isMobile ? 0 : 160,
    px: isMobile ? 1 : 2,
    py: isMobile ? 0.5 : 1,
    fontSize: isMobile ? '0.75rem' : '0.875rem',
    minHeight: isMobile ? 36 : 48,
    textTransform: 'none'
  };

  return (
    <>
      <Helmet>
        <title>My Dashboard | {AppConstants.APP_NAME}</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <Card>
            <CardHeader
              title={(
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Typography variant="h3">
                    My Dashboard
                  </Typography>
                  <Box sx={{ ml: 1, mb: 0.5 }}>  {/* Adjusted spacing */}
                    <Chip
                      label="Beta"
                      size="small"
                      sx={{
                        backgroundColor: 'rgba(144, 238, 144, 0.2)',
                        color: '#2e7d32',
                        border: '1px solid #81c784',
                        fontSize: '0.65rem',
                        height: 20,
                        '& .MuiChip-label': {
                          px: 0.75,
                        }
                      }}
                    />
                  </Box>
                </Box>
              )}
              sx={{
                flexDirection: isMobile ? 'column' : 'row',
                alignItems: isMobile ? 'flex-start' : 'center',
                gap: isMobile ? '20px' : '0'
              }}
            />
            <Divider />
            <CardContent>
              <Tabs
                data-auto-id="allShiftTabs"
                value={selectedTab}
                onChange={handleTabChange}
                variant={isMobile ? 'scrollable' : 'standard'}
                scrollButtons={isMobile ? 'auto' : false}
                allowScrollButtonsMobile
                sx={{ minHeight: isMobile ? 36 : 48 }}
              >
                <Tab
                  label="Today's Shifts"
                  data-auto-id="viewOngoingShiftTab"
                  sx={tabSx}
                />
                <Tab
                  label="Vehicles"
                  data-auto-id="viewScheduledShiftTab"
                  sx={tabSx}
                />
                <Tab
                  label="Weekly Summary"
                  data-auto-id="viewCompletedShiftTab"
                  sx={tabSx}
                />
              </Tabs>
              <Divider />
              { selectedTab === 0 && (
                <DashboardToday />
              )}
              { selectedTab === 1 && (
                <LiveGeotab />
              )}
              { selectedTab === 2 && (
                // <DashboardGraphsNR />
                <DashboardFatigue />
              )}
            </CardContent>
          </Card>
        </Container>
      </Box>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({});

const mapDispatchToProps = (dispatch: any) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(MyDashboard);
